module.exports = __webpack_public_path__ + "static/media/hapticGoRoundImg4.32bdad95.jpg";